import { LegalDocumentPurpose } from '@pillar-portal/database/dist/frontend';

/** The purpose in words; the enum value is never shown. */
export function formatLegalDocumentPurpose(purpose: LegalDocumentPurpose): string {
    switch (purpose) {
        case LegalDocumentPurpose.USER_AGREEMENT:
            return 'User agreement';
        case LegalDocumentPurpose.ORGANIZATION_AGREEMENT:
            return 'Organization agreement';
    }
}
